<template>
  <div class="login-container">
    <div class="header">
      <img class="register-img" :src="projectInfo.title" alt="">
      <h1 class="store-name txt-ellipsis">{{ activityInfo.customerName }}</h1>
    </div>
    <div class="nick-name" v-if="activityInfo.employeeName">Name：{{ activityInfo.employeeName }}</div>
    <!-- <van-field class="anth-code" v-if="!isLoginCode" v-model="authorizationCode" label="" placeholder="Authorization Code" /> -->
    <LoginCode ref="loginCodeRef" :isLoginCode="isLoginCode" />
    <van-button type="warning" class="login-btn" @click="submitLogin">Login</van-button>
    <div v-if="!isLoginCode" class="code-tip" @click="isLoginCode=true">Forgot Authorization Code</div>
    <div v-if="isLoginCode" class="bottom-info">Message and data rates my apply. Enter your phone number to accept a one-time SMS verification code to log in. Msg freg may vary. Reply &quot;HELP&quot; for help. Reply &quot;STOP&quot; to cancel.</div>
  </div>
</template>

<script>
import { appLoginApi, activityInfoApi, activityEmployeeSmsLoginApi, activityEmployeeGetByPhoneApi } from '@/api'
import { Toast } from 'vant'
import { mapMutations } from 'vuex'
export default {
  name: 'Login',
  components: {
    LoginCode: () => import('./LoginCode')
  },
  data () {
    return {
      shareKey: '',
      isLoginCode: false
    }
  },
  created () {
    this.clearData()
    let url = window.location.href // 或直接使用完整URL
    if (process.env.NODE_ENV === 'development') {
      // url = 'https://192.168.23.12:8082/#/register?shareKey=5666212fafe4454ad42b1f1ca32178dd'
    } else {
      url = window.location.href // 或直接使用完整URL
    }
    // 当前页面的 URL
    const urlObj = new URL(url)

    // 优先从 search (标准 URL 参数) 获取
    let params = new URLSearchParams(urlObj.search)
    let key = params.get('shareKey')

    // 如果 search 中没有，尝试从 hash (Vue Hash 模式参数) 中获取
    // 例如: https://.../#/register?shareKey=...
    if (!key && urlObj.hash.includes('?')) {
      const hashPart = urlObj.hash.split('?')[1]
      if (hashPart) {
        params = new URLSearchParams(hashPart)
        key = params.get('shareKey')
      }
    }
    // 获取特定参数的值
    this.shareKey = key // 返回 'sada'
    this.getActivityInfo()
    // // 获取所有参数
    // for (const [key, value] of params.entries()) {
    //     console.log(key, value); // 输出: dsad sada
    // }
  },
  methods: {
    ...mapMutations(['setToken', 'setUSERINFO', 'setActivityInfo']),
    submitLogin () {
      let data = {
        customerId: this.activityInfo.customerId
      }
      const { formData = {} } = this.$refs.loginCodeRef
      const phone = `${formData.phone}`
      // 授权码登录
      if (!this.isLoginCode) {
        if (!this.activityInfo.employeeId && !formData.phone) {
          Toast('Please enter complete Phone number')
          return
        }
        if (!formData.authorizationCode) {
          Toast('Please Enter Authorization Code')
          return
        }
        data.code = formData.authorizationCode
        data.phone = phone
      } else {
        let isFlag = true
        this.$refs.loginCodeRef.formRules.find(subItem => {
          if (!formData[subItem.value]) {
            Toast(subItem.label)
            isFlag = false
            return subItem
          }
        })
        if (!isFlag) return
        data = {
          ...data,
          ...formData,
          employeeId: this.activityInfo.employeeId,
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          phone: !this.activityInfo.employeeId ? phone : this.activityInfo.phone
        }
      }
      Toast.loading({
        message: 'loading...',
        forbidClick: true,
        duration: 0
      })
      const newPhone = !this.activityInfo.employeeId ? `${formData.phone}` : this.activityInfo.phone
      const requestApi = this.isLoginCode ? activityEmployeeSmsLoginApi : appLoginApi
      activityEmployeeGetByPhoneApi(this.activityInfo.customerId, newPhone).then(result => {
        requestApi(data).then(res => {
          Toast.clear()
          const { token, user, code, shareKey } = res.data
          this.setToken(token)
          this.setUSERINFO({ ...user, shareKey: shareKey, code, employeeId: this.activityInfo.employeeId })
          this.setActivityInfo({ ...this.activityInfo, shareKey: shareKey })
          if (this.isLoginCode) {
            localStorage.setItem('isLoginCode', '1')
          }
          this.$router.push('/activity')
        }).catch(err => {
          console.log(err)
          // Toast.clear()
        })
      })
    },
    getActivityInfo () {
      Toast.loading({
        message: 'loading...',
        forbidClick: true,
        duration: 0
      })
      activityInfoApi(this.shareKey).then(res => {
        Toast.clear()
        const { phone } = res.data
        // res.data.newPhone = `(${phone.substring(0, 3)})***-${phone.substring(6)}`
        res.data.newPhone = phone
        this.setActivityInfo(res.data)
        this.getEmployeeInfoData()
      })
    },
    clearData () {
      const activityInfo = localStorage.getItem('activityInfo')
      const myUserInfo = localStorage.getItem('myUserInfo')
      const usToken = localStorage.getItem('usToken')
      if (activityInfo) localStorage.removeItem('activityInfo')
      if (myUserInfo) localStorage.removeItem('myUserInfo')
      if (usToken) localStorage.removeItem('usToken')
    },
    getEmployeeInfoData () {
      // if (this.activityInfo.employeeId && this.activityInfo.employeeId !== 'null') {
      //   Toast.loading({
      //     message: 'loading...',
      //     forbidClick: true,
      //     duration: 0
      //   })
      //   activityEmployeeInfoApi(this.activityInfo.employeeId).then(res => {
      //     Toast.clear()
      //     const { phone } = res.data
      //     if (phone) {
      //       res.data.newPhone = `(${phone.substring(0, 3)})***-${phone.substring(6)}`
      //     }
      //     this.employeeInfo = res.data
      //   })
      // }
    }
  }
}
</script>

<style lang="less" scoped>
.login-container {
  height: 100vh;
  background: #fff;
  position: relative;
  padding: 66px 13px 0;
  box-sizing: border-box;
  font-size: 12px;
  .header {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 16px;
    .register-img {
      width: 58px;
      // height: 58px;
      margin-bottom: 10px;
    }
    .store-name {
      text-align: center;
      width: 100%;
      font-size: 18px;
      font-weight: bold;
      color: #333;
    }
    .subtitle {
      font-size: 12px;
      color: #666;
    }
  }
  .nick-name {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .login-btn {
    width: 100%;
    background-color: #ee541b;
    border-radius: 16px;
  }
  .code-tip {
    margin-top: 16px;
    text-align: center;
    color: #ee541b;
  }
  .bottom-info {
    margin-top: 20px;
    font-size: 10px;
    color: #7f7f7f;
    word-break: break-word;
  }
}
</style>
